import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Link } from 'react-router';


class BFWFeaturedOfferCard extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let offerId = this.props.offerId;
    let orgLogoUrl = this.props.orgLogoUrl;
    let organizationName = this.props.organizationName;
    let websiteUrl = this.props.website;
    let organizationId = this.props.organizationId;
    let organizationSlug = this.props.organizationSlug;

    let wwwOrgDetailPageUrl = '';
    wwwOrgDetailPageUrl = '/organizations/' + organizationId + '/' + organizationSlug;


    return(


          <a href={wwwOrgDetailPageUrl} target="_blank"><div className="featuredOfferCard">


            <div className="featuredOfferCard-logo">
              <img src={orgLogoUrl} />
            </div>



            <div className="featuredOfferCard-orgName">
              {organizationName}
            </div>


          </div></a>


    )
  }
}

function mapStateToProps(state) {
  return state;
};

export default connect(
  mapStateToProps,
  {
    push,
    Link
  }
)(BFWFeaturedOfferCard);



// WEBPACK FOOTER //
// ./src/components/bfwOffers/BFWFeaturedOfferCard.jsx